import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-slate-200 bg-slate-100 text-slate-700 hover:bg-slate-200',
        secondary:
          'border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100',
        destructive:
          'border-red-200 bg-red-50 text-red-700 hover:bg-red-100',
        success: 'border-green-200 bg-green-50 text-green-700 hover:bg-green-100',
        outline: 'border-slate-300 bg-transparent text-slate-700 hover:bg-slate-50',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
